import {
  Constraint,
  Event,
  Id,
  Identifiable,
  List,
  list,
  Milestone,
  milestone,
  Task,
  task,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded?: {
    constraints?: (Identifiable<Constraint> & {
      originEntity:
        | Identifiable<Task>
        | Identifiable<List>
        | Identifiable<Event>
        | Identifiable<Milestone>;
      targetEntity:
        | Identifiable<Task>
        | Identifiable<List>
        | Identifiable<Event>
        | Identifiable<Milestone>;
    })[];
  };
};

function padElement(
  elementType: Constraint["originEntityType"] | Constraint["targetEntityType"],
  element:
    | Identifiable<Task>
    | Identifiable<List>
    | Identifiable<Event>
    | Identifiable<Milestone>,
) {
  return elementType === "ACTIVITY"
    ? { ...list, ...element }
    : elementType === "MILESTONE"
      ? { ...milestone, ...element }
      : { ...task, ...element };
}

function getElementConstraints(httpClient: HttpClient) {
  return (
    elementId: Id,
    elementType: "task" | "list" | "milestone" | "event",
  ) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/constraints/search/rsql?query=targetEntityUuid==${elementId},originEntityUuid==${elementId}&projection=details&size=999`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) => (_embedded ? _embedded.constraints || [] : []))
      .then((constraints) =>
        constraints.map((constraint) => {
          const isOrigin = constraint.originEntityUuid === elementId;
          const linkedElementType = isOrigin
            ? constraint.targetEntityType
            : constraint.originEntityType;
          const linkedElementId = isOrigin
            ? constraint.targetEntityUuid
            : constraint.originEntityUuid;

          return {
            ...constraint,
            origin: padElement(
              constraint.originEntityType,
              constraint.originEntity,
            ),
            target: padElement(
              constraint.targetEntityType,
              constraint.targetEntity,
            ),
          };
        }),
      );
}

export { getElementConstraints };
